import { render, staticRenderFns } from "./RegistrationScreen.vue?vue&type=template&id=60f2ed48&scoped=true&"
import script from "./RegistrationScreen.vue?vue&type=script&lang=js&"
export * from "./RegistrationScreen.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationScreen.vue?vue&type=style&index=0&id=60f2ed48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f2ed48",
  null
  
)

export default component.exports